import React from 'react';
import { NumberField, SimpleShowLayout } from 'react-admin';
import Heading from 'components/Heading';

type FeesSectionProps = {
  settingsField: string;
};

export const FeesSection = ({ settingsField }: FeesSectionProps) => {
  return (
    <SimpleShowLayout spacing={0} sx={{ padding: 0, marginBottom: 3 }}>
      <Heading>Fees</Heading>

      <NumberField
        label="Cancellation Fee Window"
        source={`${settingsField}.cancellation_fee_window`}
      />
      <NumberField
        label="Cancellation Fee Charge Hours"
        source={`${settingsField}.cancellation_fee_charge_hours`}
      />

      <NumberField
        label="Agency VMS Fee Percent"
        source={`${settingsField}.agency_vms_fee_percent`}
      />
    </SimpleShowLayout>
  );
};
